
import React, { useState } from "react";
import ViewToggle, { ViewMode } from "./view-toggle";

export interface ViewSwitcherProps<T> {
  items: T[];
  storageKey?: string;
  renderCard: (item: T, index: number) => React.ReactNode;
  renderListItem: (item: T, index: number) => React.ReactNode;
  renderEmptyState?: () => React.ReactNode;
  className?: string;
  cardContainerClassName?: string;
  listContainerClassName?: string;
}

export function ViewSwitcher<T>({
  items,
  storageKey,
  renderCard,
  renderListItem,
  renderEmptyState,
  className = "",
  cardContainerClassName = "grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  listContainerClassName = "flex flex-col gap-2",
}: ViewSwitcherProps<T>) {
  const [viewMode, setViewMode] = useState<ViewMode>("card");

  // Display empty state if no items
  if (items.length === 0 && renderEmptyState) {
    return renderEmptyState();
  }

  return (
    <div className={className}>
      <div className="flex justify-end mb-4">
        <ViewToggle
          storageKey={storageKey}
          onChange={setViewMode}
        />
      </div>

      {viewMode === "card" ? (
        <div className={cardContainerClassName}>
          {items.map((item, index) => renderCard(item, index))}
        </div>
      ) : (
        <div className={listContainerClassName}>
          {items.map((item, index) => renderListItem(item, index))}
        </div>
      )}
    </div>
  );
}

export default ViewSwitcher;
